import styles from '../../styles/module/RootLayout.module.scss'
import Abidata from './../../images/abidadeh.svg'

const Footer = () => {
  return (
    <div className={styles.footerWrapper}>
      <div className="gtranslate_wrapper" style={{ marginTop: '2rem', background: 'var(--background-color)', padding: '.5rem', margin: '0 auto', textAlign: 'center' }}></div>
      <footer className={styles.footer}>
        <p>کلیه حقوق برای سازمان فناوری اطلاعات و ارتباطات شهرداری اردبیل محفوظ است.</p>
        <div className="text-center d-flex align-items-center justify-content-center">
          <a referrerpolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=654266&Code=LfERZWKdtyavdyIVxCNzWpmLD8uVproI">
            <img referrerpolicy="origin" src="https://trustseal.enamad.ir/logo.aspx?id=654266&Code=LfERZWKdtyavdyIVxCNzWpmLD8uVproI" alt="" style={{ cursor: `pointer` }} code="LfERZWKdtyavdyIVxCNzWpmLD8uVproI" />
          </a>
        </div>

        <div className={styles.abidata}>
          <a href="https://abidadeh.com" target={`_blank`} rel="author">
            <img alt={`آبی داده`} src={Abidata} />
            <div>
              <span>پشتیبانی توسط شرکت آبی داده</span>
            </div>
          </a>
        </div>
      </footer>
    </div>
  )
}

export default Footer
